import React from 'react';
import { motion } from 'framer-motion';
const skills = ['Enterprise Risk Management', 'Treasury & Liquidity Strategy', 'Derivatives & Structured Products', 'ISDA/CSA Negotiations', 'Counterparty Credit Risk', 'Capital Allocation & Optimization', 'Regulatory Compliance (Basel III/IV)', 'Market Risk & VaR Modeling', 'Hedge Accounting (FAS 133/ASC 815)', 'Board & C-Suite Advisory', 'Global Team Leadership', 'Financial Performance Alignment'];
export function Skills() {
  return <section id="skills" className="py-24 bg-bg-alt" data-id="element-94">
      <div className="max-w-[1100px] mx-auto px-6 md:px-12" data-id="element-95">
        <motion.div initial={{
        opacity: 0,
        y: 20
      }} whileInView={{
        opacity: 1,
        y: 0
      }} viewport={{
        once: true,
        margin: '-100px'
      }} transition={{
        duration: 0.6
      }} data-id="element-96">
          <h3 className="font-sans text-sm font-semibold tracking-[0.2em] text-accent uppercase flex items-center gap-4 mb-16" data-id="element-97">
            Core Competencies
            <span className="h-[1px] flex-1 bg-accent/20 max-w-[200px]" data-id="element-98"></span>
          </h3>

          <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-3 gap-x-8 gap-y-6" data-id="element-99">
            {skills.map((skill, index) => <motion.div key={index} initial={{
            opacity: 0,
            y: 10
          }} whileInView={{
            opacity: 1,
            y: 0
          }} viewport={{
            once: true
          }} transition={{
            duration: 0.4,
            delay: index * 0.05
          }} className="flex items-start gap-4 p-4 bg-white border border-slate-100 shadow-sm hover:shadow-md transition-shadow duration-300" data-id="element-100">
                <span className="text-gold text-sm mt-0.5" data-id="element-101">◆</span>
                <span className="text-primary font-sans text-sm font-medium leading-snug" data-id="element-102">
                  {skill}
                </span>
              </motion.div>)}
          </div>
        </motion.div>
      </div>
    </section>;
}